import { render, staticRenderFns } from "./InvestmentDetail.vue?vue&type=template&id=4f4ce8f9&scoped=true&"
import script from "./InvestmentDetail.vue?vue&type=script&lang=js&"
export * from "./InvestmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentDetail.vue?vue&type=style&index=0&id=4f4ce8f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ce8f9",
  null
  
)

export default component.exports